module.exports = __webpack_public_path__ + "img/header-img.2ad77d1b.png";